<template>
  <div>
    <v-dialog v-model="dialog.image"
          @keydown.esc="dialog.image = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="pt-6">
            <v-card-title 
              class="d-flex align-center py-0 pb-4 text-right popup-header fs-20 font-weight-bold">
              
              Gambar Toko

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#4828a1">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.image = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon> -->

              <v-icon 
                @click="dialog.image = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light pa-6 pt-0 text-first line-text-second my-0 py-3" v-if="Object.keys(detail).length > 0">
              <v-row>
                <!-- <v-col>
                  <div>
                    <div>
                      Nama Sales
                    </div>
                    <div class="fs-15 label-input">
                      {{ detail.sales_name }}
                    </div>
                  </div>
                  <div>
                    <div>
                      Nama Customer
                    </div>
                    <div class="fs-15 label-input">
                      {{ detail.customer_name }}
                    </div>
                  </div>
    
                  <div>
                    <div>
                      Nama Toko
                    </div>
                    <div class="fs-15 label-input">
                      {{ detail.store_name }}
                    </div>
                  </div>

                  <div>
                    <div>
                      Tipe
                    </div>
                    <div class="fs-15 label-input">
                      {{ detail.type }}
                    </div>
                  </div>

                  <div>
                    <div>
                      Catatan
                    </div>
                    <div class="fs-15 label-input">
                      {{ detail.note === '' ? '-' : detail.note }}
                    </div>
                  </div>

                </v-col> -->
                
                <v-col>

                  <div>
                    <div class="fs-15 label-input text-center justify-center">
                      <v-img
                        contain
                        width="350"
                        height="350"
                        :src="image_url" 
                        :alt="image_url"
                        class="text-center d-flex align-center mx-auto">
                      </v-img>
                    </div>
                  </div>

                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>


        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
    <v-row
      class="pa-4 pr-1">
      <v-col 
        cols="12"
        class="py-0">
        <v-card 
          flat>

          <v-card-text
            v-if="Object.keys(detail).length < 1" 
            class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
            <div class="text-center">
              <div class="mb-2 title">
                Mohon Tunggu...
              </div>
              <v-progress-circular
                indeterminate
              ></v-progress-circular>
            </div>
          </v-card-text>

          <v-card-text v-if="Object.keys(detail).length > 0">
            
            <div>
              <div class="d-flex mb-3 mt-0">
                <div>
                  <div class="fs-16 color-dark-blue font-weight-medium">
                    Toko
                  </div>
                </div>
                <v-spacer />
                <div>
                  <!-- @click="dialog.form = true; reset();" -->
                  <!-- <v-btn
                    color="#6948c6"
                    width="195"
                    height="35"
                    elevation="0"
                    style="border-radius: 9px;"
                    :to="`/customer/toko/add/${detail.id}`"
                    class="fs-16 white--text text-capitalize">
                    <v-icon size="18" class="mr-1 pt-1">mdi-plus</v-icon>
                    Tambah Toko
                  </v-btn> -->
                </div>
              </div>
              <v-row>
                <v-col cols="12" md="12" v-for="(item, index) in detail.store" :key="index">
                  <v-card
                    class="pa-0"
                    height="100%"
                    flat
                    style="border-radius: 15px; border: 1px solid #E7E7E7;">
                    <v-toolbar
                      :color="set_color"
                      dark>
                      <v-toolbar-title class="body-1 font-weight-bold text-capitalize">
                        {{ item.store_name }}
                      </v-toolbar-title>

                      <v-spacer></v-spacer>

                      <!-- <v-tooltip 
                      top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :to="`/customer/toko/detail/${item.store_id}`"
                          
                          v-bind="attrs"
                          v-on="on"

                          min-width="28"
                          small
                          rounded
                          color="white"
                          elevation="0"
                          class="text-capitalize mx-1 px-0"
                          style="font-weight: 600; border-radius: 6px;">
                          <v-icon small color="#4828a1">mdi-information-outline</v-icon>
                        </v-btn>
                      </template>

                      <span>Detail</span>
                    </v-tooltip> -->

                    </v-toolbar>

                    <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                      {{ item.store_name }}
                    </v-card-text> -->

                    <v-card-text class="body-2 font-weight-light text-first">
                      <!-- <p class="mb-2">
                        <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                        <span v-if="item.start === item.end">
                          Tanggal <b>{{ item.date | date }}</b>
                        </span>
                      </p> -->

                      <!-- <p class="mb-2">
                        <v-icon small class="mr-2">mdi-account</v-icon>
                        <span>
                          <b>{{ item.store_pic_name }}</b>
                        </span>
                      </p> -->

                      <!-- <p class="mb-2">
                        <v-icon small class="mr-2">mdi-map-marker</v-icon>
                        <span>
                          <b>{{ item.store_address }}</b>
                        </span>
                      </p> -->
                      <v-row>
                        <v-col cols="12" md="6" class="pb-0">
                          <table style="width: 100%;">
                            <tr>
                              <td style="width: 100px; min-width: 100px;">
                                PIC
                              </td>
                              <td style="max-width: 30px; min-width: 30px; width: 30px;" class="text-center">
                                :
                              </td>
                              <td class="py-1 font_weight_600 black--text" style="width: 100%;">
                                {{ item.store_pic_name !== '' ? item.store_pic_name : '-'}}
                              </td>
                            </tr>
                            <tr>
                              <td style="width: 100px; min-width: 100px;">
                                Tipe Toko
                              </td>
                              <td style="max-width: 30px; min-width: 30px; width: 30px;" class="text-center">
                                :
                              </td>
                              <td class="py-1 font_weight_600 black--text" style="width: 100%;">
                                {{ item.store_type !== '' ? item.store_type : '-'}}
                              </td>
                            </tr>
                            <tr>
                              <td style="width: 100px; min-width: 100px;">
                                Kode Outlet
                              </td>
                              <td style="max-width: 30px; min-width: 30px; width: 30px;" class="text-center">
                                :
                              </td>
                              <td class="py-1 font_weight_600 black--text" style="width: 100%;">
                                {{ item.store_code }}
                                <!-- <div class="d-flex" style="width: 100%;">
                                  <div style="width: 100%;">
                                    <v-text-field
                                      v-model="item.store_code"
                                      outlined
                                      dense
                                      class="fs-14"
                                      style="width: 100%;"
                                    ></v-text-field>
                                  </div>
                                  <div class="ml-2">
                                    <v-btn
                                      color="#6948c6"
                                      width="100"
                                      height="50"
                                      :loading="process.form"
                                      :disabled="process.form"
                                      elevation="0"
                                      @click="save(item)"
                                      style="border-radius: 4px;"
                                      class="fs-16 white--text text-capitalize">
                                      Simpan
                                    </v-btn>
                                  </div>
                                </div> -->
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Alamat
                              </td>
                              <td style="max-width: 30px; min-width: 30px; width: 30px;" class="text-center">
                                :
                              </td>
                              <td class="py-1 font_weight_600 black--text" style="width: 100%;">
                                {{ item.store_village_name !== '' ? item.store_village_name : '-'}}, {{ item.store_subdistrict_name !== '' ? item.store_subdistrict_name : '-'}}, {{ item.store_city_name !== '' ? item.store_city_name : '-'}} - {{ item.store_province_name !== '' ? item.store_province_name : '-'}}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Detail Alamat
                              </td>
                              <td style="max-width: 30px; min-width: 30px; width: 30px;" class="text-center">
                                :
                              </td>
                              <td class="py-1 font_weight_600 black--text" style="width: 100%;">
                                {{ item.store_address_detail !== '' && item.store_address_detail !== null ? item.store_address_detail : '-'}}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Catatan
                              </td>
                              <td style="max-width: 30px; min-width: 30px; width: 30px;" class="text-center">
                                :
                              </td>
                              <td class="py-1 font_weight_600 black--text" style="width: 100%;">
                                {{ item.store_notes !== '' ? item.store_notes : '-'}}
                              </td>
                            </tr>
                          </table>
                        </v-col>
                        <v-col cols="12" md="6" class="pb-0">
                          <div class="">
                            <div v-if="item.store_latitude === ''">
                              -
                            </div>
                            <div v-if="item.store_latitude !== ''">
                                    <iframe 
                                      width="100%" 
                                      height="170" 
                                      frameborder="0" 
                                      scrolling="no" 
                                      marginheight="0" 
                                      marginwidth="0" 
                                      language="id"
                                      :src="`https://www.google.com/maps/embed/v1/place?key=AIzaSyCpSBm0ehBiEr4muaISG3Rgm_UNR6Bfd5M&q=${item.store_latitude},${item.store_longitude}&language=id`"
                                      >
                                    </iframe>
                            </div>
                            <!-- <div v-if="item.store_latitude !== ''">
                              <gmap-map
                                :center="{
                                  lat: (item.store_latitude)*1,
                                  lng: (item.store_longitude)*1
                                }"
                                :zoom="16"
                                :options="{
                                  zoomControl: true,
                                  mapTypeControl: false,
                                  scaleControl: false,
                                  streetViewControl: false,
                                  rotateControl: false,
                                  fullscreenControl: true,
                                  disableDefaultUi: false
                                }"
                                style="width: 100%; height: 170px;">
      
                                <gmap-marker
                                  :position="{
                                    lat: (item.store_latitude)*1,
                                    lng: (item.store_longitude)*1
                                  }">
                                </gmap-marker>
                              </gmap-map>
                            </div> -->
                          </div>
                        </v-col>
                        <v-col cols="12" md="12" class="pt-0">
                          <div>
                            <div 
                              class="fs-14">
                              <!-- <span class="red--text">*</span> -->
                              Gambar 
                          </div>
                          <v-row>
                            <v-col 
                              v-for="(item, index) in item.store_images"
                              :key="index"
                              cols="12"
                              md="2">
                              <v-card 
                                flat
                                width="100%"
                                height="135"
                                @click="dialog.image = true; image_url = item"
                                class="d-flex align-center justify-center"
                                style="border-radius: 15px;
                                      border: 2px solid #eaeaea; 
                                      border-style: dashed;
                                      box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px; ">
                                <v-img 
                                  alt="megavin" 
                                  width="100%"
                                  height="125"
                                  :src="item"
                                  contain
                                  class="ma-auto">
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        indeterminate 
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>
    
                                  <!-- <div 
                                    @click="form.images.splice(index, 1)"
                                    class="cursor-pointer"
                                    style="position: absolute; top: 5px; right: 5px;">
                                    <v-icon size="24" color="red">mdi-close-circle</v-icon>
                                  </div> -->
                                </v-img>
                              </v-card>
                            </v-col>
                          </v-row>
    
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <div v-if="message.error.length > 0"
              class="text-center my-4 d-flex align-center">
              <div
                class="error--text">
                <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>


<script>
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      props: {
        detail: {
          type: Object,
          default: {}
        }
      },
      data () {
        return {
          dialog:{
            image: false,
            snackbar: false,
          },
          image_url: '',
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          menu: false,
          modal: false,
          menu2: false,
          
          zoomed: false,
          zoomedTtd: false,
          imageAspectRatio: 1,
          imageAspectRatioTtd: 1,

          center: {
            lat: 0,
            lng: 0
          },
  
          process: {
            form: false,
          },
          
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {

      },
      watch: {
        
      },
      computed: {
        user () {
          return this.$store.state.user
        },
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        }
      },
      mounted () {
      },
      methods: {
        onImageLoad(e) {
          const img = e.target
          this.imageAspectRatio = img.naturalWidth / img.naturalHeight
        },
        onImageLoadAkta(e) {
          const img = e.target
          this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
        },
        async save (item) {
        this.message.error = ''

        item.store_code = item.store_code.length > 0 ? item.store_code : ' '

        const isValid = true
        if (isValid) {
          let form = {
            id: item.store_id,
            code: item.store_code
          }
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/toko/update`, {
            data: form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
      }
    }
  </script>